import Select from "react-select";
import { showErrorMessage } from "./ShowFeildValidationError.jsx";

const GenericMultiSelectField = ({
  label,
  name,
  isMulti = true,
  options,
  value,
  onChange,
  errorMessage,
  required = false,
}) => {
  return (
    <div className="form-group row">
      <label
        className={`col-sm-3 form-control-label content-body ${
          required ? "required" : ""
        }`}
      >
        {label}
      </label>

      <div className="col-sm-9">
        <Select
          name={name}
          isMulti={isMulti}
          options={options}
          value={value}
          className="basic-multi-select fields-font"
          onChange={onChange}
        />
      </div>

      {errorMessage && showErrorMessage(errorMessage)}
    </div>
  );
};

export default GenericMultiSelectField;
